import { Icon } from './Icon.tsx';
import { dv } from '../i18n/dv.ts';

interface Props {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, pageSize, total, onChange }: Props): JSX.Element | null {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0 || totalPages <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <nav
      aria-label={dv.common.page}
      className="flex items-center justify-between gap-3 pt-3 border-t border-border/70"
    >
      <p className="mono-meta tabular text-muted-foreground">
        {from}–{to} / {total}
      </p>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => canPrev && onChange(page - 1)}
          disabled={!canPrev}
          aria-label={dv.common.prev}
          className="inline-flex size-9 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <Icon name="chevron_left" size={16} />
        </button>
        <span className="mono-meta tabular text-ink px-2">
          {dv.common.page} {page} / {totalPages}
        </span>
        <button
          type="button"
          onClick={() => canNext && onChange(page + 1)}
          disabled={!canNext}
          aria-label={dv.common.next}
          className="inline-flex size-9 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <Icon name="chevron_right" size={16} />
        </button>
      </div>
    </nav>
  );
}
